var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyUsIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 36.6668V6.66683C10 5.78277 10.3512 4.93493 10.9763 4.30981C11.6014 3.68469 12.4493 3.3335 13.3333 3.3335H26.6667C27.5507 3.3335 28.3986 3.68469 29.0237 4.30981C29.6488 4.93493 30 5.78277 30 6.66683V36.6668H10Z",
    stroke: "#8B5CF6",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 20H6.66536C5.78131 20 4.93346 20.3512 4.30834 20.9763C3.68322 21.6014 3.33203 22.4493 3.33203 23.3333V33.3333C3.33203 34.2174 3.68322 35.0652 4.30834 35.6904C4.93346 36.3155 5.78131 36.6667 6.66536 36.6667H9.9987",
    stroke: "#8B5CF6",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15H33.3333C34.2174 15 35.0652 15.3512 35.6904 15.9763C36.3155 16.6014 36.6667 17.4493 36.6667 18.3333V33.3333C36.6667 34.2174 36.3155 35.0652 35.6904 35.6904C35.0652 36.3155 34.2174 36.6667 33.3333 36.6667H30",
    stroke: "#8B5CF6",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.668 10H23.3346",
    stroke: "#8B5CF6",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.668 16.6665H23.3346",
    stroke: "#8B5CF6",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.668 23.3335H23.3346",
    stroke: "#8B5CF6",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.668 30H23.3346",
    stroke: "#8B5CF6",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyUsIcon1);
export default __webpack_public_path__ + "static/media/WhyUs-icon-1.a4a20146e9b3f2872ae4e4c67a2fe706.svg";
export { ForwardRef as ReactComponent };